<template>
  <div class="upgrade">
    <div class="controls">
      <textbook-category-select
        :key="courseTypeCode + '-' + categoryCode + '-' + textbookVersion"
        :course-type-code="courseTypeCode"
        :category-code="categoryCode"
        :version="textbookVersion"
        @change="selectLevels"
      />

      <el-form
        ref="form"
        class="select-textbook"
        label-width="80px"
      >
        <el-form-item
          ref="textbookSelectForm"
          label="教材"
        >
          <el-cascader
            v-model="textbookValue"
            style="min-width: 620px"
            filterable
            :props="selectionProps"
            :options="levels"
            @change="selectTextbook"
          >
            <template slot-scope="{ node, data }">
              <span style="float: left">{{ data.name }}</span>
              <span
                v-if="data.isUsed === 0"
                style="float: right; color: #8492a6; font-size: 13p"
              >{{ $t("禁用") }}</span>
            </template>
          </el-cascader>
        </el-form-item>
      </el-form>

      <div class="add">
        <el-button
          v-if="$hasPermission('upgradeCreate')"
          icon="el-icon-plus"
          size="small"
          :disabled="!$route.query.levelId"
          @click="
            $router.push({
              name: 'upgradeAdd',
              params: { levelId: $route.query.levelId },
            })
          "
        >
          新增试卷
        </el-button>
      </div>
    </div>

    <el-table
      :data="upgradeVersions"
      style="width: 100%"
    >
      <el-table-column
        fixed
        label="online"
        width="70"
      >
        <template slot-scope="scope">
          <div
            :class="{ online: scope.row.online, offline: !scope.row.online }"
          />
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="version"
        label="版本号"
        width="80"
      />
      <el-table-column
        label="支持设备"
        width="100"
      >
        <template slot-scope="scope">
          <i
            v-for="device of scope.row.devices"
            :key="device"
            class="iconfont"
            :class="{
              'icon-iphone': device === 'mobile',
              'icon-ipad': device === 'pad',
              'icon-pc': device === 'pc',
            }"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="试卷名"
        width="200"
      />
      <el-table-column
        prop="describe"
        width="300"
        label="试卷描述"
      />

      <el-table-column
        label="状态"
        width="100"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              scope.row.checkingStatus === 'rejected' &&
                !!scope.row.checkingMessage
            "
            class="item"
            effect="dark"
            :content="scope.row.checkingMessage"
            placement="top"
          >
            <span>{{ scope.row.checkingStatus || "-" | checkStatus }}</span>
          </el-tooltip>
          <span v-else>{{
            scope.row.checkingStatus || "-" | checkStatus
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="发布人"
        width="110"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.publishedBy || "-" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="发布时间"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.publishedAt | dateFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        width="180"
      >
        <template slot-scope="scope">
          <div class="operate">
            <!-- 审核中和审核后不能编辑 -->
            <el-button
              v-if="
                $hasPermission('upgradeEdit') &&
                  scope.row.checkingStatus !== 'waiting' &&
                  scope.row.checkingStatus !== 'resolved'
              "
              size="small"
              type="text"
              @click="
                $router.push({
                  name: 'upgradeEdit',
                  params: { levelId: $route.query.levelId },
                  query: { version: scope.row.version },
                })
              "
            >
              {{ $t("编辑") }}
            </el-button>

            <el-button
              v-if="
                $hasPermission('upgradeDelete') &&
                  scope.row.checkingStatus !== 'waiting' &&
                  scope.row.checkingStatus !== 'resolved'
              "
              size="small"
              type="text"
              @click="deleteVersion(scope.row.version)"
            >
              {{ $t("删除") }}
            </el-button>

            <el-dropdown
              trigger="hover"
              @command="preview"
            >
              <el-button
                size="small"
                type="text"
              >
                {{ $t("预览") }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{'version': scope.row.version,'device': 'mobile','metalang':'zh-CN'}"
                  class="iconfont"
                >
                  <el-button
                    size="small"
                    type="text"
                  >
                    国内
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item
                  v-for="(item,key) in languages"
                  :key="key"
                  :command="{'version': scope.row.version,'device': 'mobile','metalang':item.value}"
                  class="iconfont"
                >
                  <el-button
                    size="small"
                    type="text"
                  >
                    {{ item.name }}
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              v-if="
                $hasPermission('upgradeCheck') &&
                  scope.row.checkingStatus === 'waiting'
              "
              size="small"
              type="text"
              @click="
                $router.push({
                  name: 'upgradeCheck',
                  params: { levelId: $route.query.levelId },
                  query: { version: scope.row.version },
                })
              "
            >
              {{ $t("审校") }}
            </el-button>

            <el-button
              v-if="
                $hasPermission('unitTestPublish') &&
                  scope.row.checkingStatus === 'resolved' &&
                  !scope.row.online
              "
              size="small"
              type="text"
              @click="publish(scope.row.version)"
            >
              {{ $t("发布") }}
            </el-button>

            <el-dropdown
              trigger="hover"
              @command="rePublish"
            >
              <el-button
                size="small"
                type="text"
              >
                {{ $t("重新发布") }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item,key) in languages"
                  :key="key"
                  :command="{'version': scope.row.version,'metalang': item.value}"
                  class="iconfont"
                >
                  <el-button
                    size="small"
                    type="text"
                  >
                    {{ item.name }}
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              v-if="
                $hasPermission('unitTestCreate') &&
                  scope.row.checkingStatus === 'resolved'
              "
              size="small"
              type="text"
              @click="fork(scope.row.version)"
            >
              {{ $t("复制") }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="forkDialogVisible">
      <fork-upgrade
        v-if="forkVersion"
        :id="$route.query.levelId"
        :key="($route.query.levelId || '') + '-' + forkVersion"
        type="up"
        :version="forkVersion"
        @close="forkClose"
      />
    </el-dialog>

    <el-dialog
      :visible.sync="upgradeDialogVisible"
      width="240px"
      @close="closeUpgradeDialog"
    >
      <qrcode
        v-if="currentUpgradeUrl"
        :text="currentUpgradeUrl"
        :show-text="true"
      />
    </el-dialog>
  </div>
</template>
<style lang="less" scoped>
.controls {
  position: relative;
  .add {
    position: absolute;
    right: 30px;
    bottom: 0;
  }
}

.operate {
  .el-button {
    margin-right: 10px;
  }
}

.offline,
.online {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  border: #8bc34a 1px solid;
}

.online {
  background-color: #8bc34a;
}
</style>
<script>
const debug = require('debug')('ccs:ctrl:upgrade-test');
import axios from 'axios';
import qrcode from '../components/qrcode';
import fork from '../components/fork';
import textbookCategorySelect from '../components/textbook_category_select';
import {
	getTextbook,
	getTextbookChildren,
	getTextbookParent,
} from '../service/textbook';

export default {
	components: {
		forkUpgrade: fork,
		textbookCategorySelect,
		qrcode,
	},
	data() {
		return {
			selectionProps: {
				// lazy: true,
				value: 'id',
				label: 'name',
				// expandTrigger: 'hover'
			},

			forkDialogVisible: false,
			forkVersion: null,

			// 教材分类
			levels: [],
			courseTypeCode: '',
			categoryCode: '',
			textbookVersion: '',
			textbookValue: [],
			levelId: null,

			// 试卷版本信息
			upgradeVersions: [],
			currentUpgradeUrl: '',
			upgradeDialogVisible: false,
			languages: []
		};
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		'$route.query.levelId': async function (curr, prev) {
			await this.search();
			// if (curr !== prev) {
			//   await this.init();
			// } else {
			//   await this.search();
			// }
		},
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			debug('[init]');
			const { levelId } = this.$route.query;
			if (levelId) {
				const level = await getTextbook({ textbookId: levelId });

				debug(
					'[init] levelId: %s, courseTypeCode: %s, categoryCode: %s, textbookVersion: %s',
					level.id,
					level.courseTypeCode,
					level.categoryCode,
					level.version
				);

				this.courseTypeCode = level.courseTypeCode;
				this.categoryCode = level.categoryCode;
				this.textbookVersion = level.version;
				this.textbookValue = [level.id];
			}
			this.languages = await axios.get('/api/languages');
			await this.search();
		},

		// 单元测试题所有版本
		async search() {
			const { levelId } = this.$route.query;

			if (levelId) {
				const upgradeVersions = await axios.get(`/api/up/${levelId}/versions`);
				debug('[search] upgradeVersions: %o', upgradeVersions);
				this.upgradeVersions = upgradeVersions;
			}
		},

		async selectLevels(levels) {
			debug('[selectLevels]', levels);
			this.levels = levels;
			this.$nextTick(() => {
				this.triggerCascaderValue();
			});
		},

		selectTextbook(val) {
			const levelId = this.textbookValue[0];
			this.$router.replace({ query: { levelId } });
		},

		async deleteVersion(version) {
			const { levelId } = this.$route.query;
			if (!levelId) return;

			await axios.delete(`/api/up/${levelId}/${version}`);
			await this.search();
		},

		async preview(val) {
			const { levelId } = this.$route.query;
			if (!levelId) return;

			const { version, device,metalang } = val;

			/* eslint no-undef:0 */
			debug('[upgrade] version: %s', version);
			// const upgradeVersion = find(this.upgradeVersions, { version });
			// if (upgradeVersion.httpUrl) return;

			const urls = await axios.get(`/api/up/${levelId}/urls`, {
				params: { version },
			});
			let upgradeUrl = urls.mobile.split('?') ? urls[device].split('?')[0] : '';
			upgradeUrl = `${upgradeUrl}?preview=true&metalang=${metalang}`;
			// 替换域名，因为 itextbook.51talk.com 的 cdn 缓存会造成缓存了预览题型的数据
			upgradeUrl = upgradeUrl.replace(/^http:\/\/[^/]+/, 'http://api.ccs.51talkjr.com');
			this.currentUpgradeUrl = upgradeUrl;
			this.upgradeDialogVisible = true;
			// this.$set(upgradeVersion, 'httpUrl', urls.mobile);
		},
		// 关闭预览dialog时清除数据
		closeupgradeDialog() {
			this.currentUpgradeUrl = '';
		},

		// 题发布
		async publish(version) {
			const { levelId } = this.$route.query;
			if (!levelId) return;

			await axios.post(`/api/up/${levelId}/publish`, { version });
			await this.search();
		},
		async rePublish(val){
			const { levelId } = this.$route.query;
			if (!levelId) return;
			const { version, metalang } = val;
			const data = await axios.get('api/paper/metalang/publish', {
				params: { version:version,metalang:metalang,businessid:levelId,category:'up' },
			});
			if(data.code == 1){
				alert('success');
			}else{
				alert(data.msg);
			}
		},

		async fork(version) {
			this.forkDialogVisible = true;
			this.forkVersion = version;
			debug('[fork] version: %s', version);
		},

		async forkClose(levelId) {
			this.forkDialogVisible = false;
			this.forkVersion = null;
			if (!levelId) return; // 取消

			if (this.$route.query.levelId !== levelId) {
				this.$router.push({ query: { levelId } });
				window.location.reload();
			} else {
				await this.search();
			}
		},

		async triggerCascaderValue() {
			const { levelId } = this.$route.query;
			if (!levelId) return;

			debug('[triggerCascaderValue] levelId: %o', levelId);
			try {
				const el = this.$refs.courseSelectForm.$el.querySelector(
					'.el-cascader > .el-input > input'
				);
				if (el.value) return;

				const level = getTextbook({ textbookId: courseId });

				debug(
					'[triggerCascaderValue] name: %s', level.name
				);
				el.value = level.name;
			} catch (ignored) {}
		},
	},
};
</script>
